import { useFetchProfile } from '@/hooks/useFetchProfile'
import { cn } from '@/lib/utils'
import { NodeViewRendererProps, NodeViewWrapper } from '@tiptap/react'

export default function SlashCommandNode(props: NodeViewRendererProps & { selected: boolean }) {
  const { profile } = useFetchProfile(props.node.attrs.npub)
  const author = profile?.shortName ?? props.node.attrs.npub

  return (
    <NodeViewWrapper
      className={cn('inline text-primary', props.selected ? 'bg-primary/20 rounded-sm' : '')}
    >
      <span className="text-highlight font-semibold">/{props.node.attrs.command}</span>@
      <span className="text-sm font-light">{author}</span>
    </NodeViewWrapper>
  )
}
